import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AdminLoading from './AdminLoading';
import AdminEmptyState from './AdminEmptyState';
import { IoCalendarOutline } from 'react-icons/io5';

export default function AdminAvailability() {
  const [list, setList] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [productId, setProductId] = useState('');
  const [blockedDate, setBlockedDate] = useState('');

  const load = () => {
    api('/api/admin/availability').then(setList).catch((e) => setError(e.message)).finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    api('/api/admin/products').then(setProducts).catch(() => setProducts([]));
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!productId || !blockedDate) {
      setError('Select product and date');
      return;
    }
    setError('');
    try {
      await api('/api/admin/availability', { method: 'POST', body: JSON.stringify({ product_id: Number(productId), blocked_date: blockedDate }) });
      setBlockedDate('');
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Remove this blocked date?')) return;
    try {
      await api(`/api/admin/availability/${id}`, { method: 'DELETE' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <AdminLoading />;

  return (
    <Card>
      <CardHeader title="Blocked dates" />
      <CardContent>
        {error && <Typography color="error" className="admin-error" sx={{ mb: 2 }}>{error}</Typography>}
        <Box component="form" onSubmit={handleAdd} sx={{ mb: 3, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-end' }}>
          <TextField size="small" select SelectProps={{ native: true }} label="Product" value={productId} onChange={(e) => setProductId(e.target.value)} required sx={{ minWidth: 200 }}>
            <option value="">Select product</option>
            {products.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.code})</option>)}
          </TextField>
          <TextField size="small" type="date" label="Blocked date" value={blockedDate} onChange={(e) => setBlockedDate(e.target.value)} required InputLabelProps={{ shrink: true }} sx={{ minWidth: 160 }} />
          <Button type="submit" variant="contained">Add blocked date</Button>
        </Box>
        {list.length === 0 ? (
          <AdminEmptyState message="No blocked dates. Add one above." icon={IoCalendarOutline} />
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>Blocked date</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((a) => (
                  <TableRow key={a.id} hover>
                    <TableCell>{a.product_name || a.product_id}</TableCell>
                    <TableCell>{a.blocked_date}</TableCell>
                    <TableCell align="right">
                      <Button size="small" color="error" onClick={() => handleDelete(a.id)}>Remove</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}
